import LocalStorageKeys from '../../cache/LocalStorageKeys'

const RestApiUtils = {

  get: (context, resource, callback, pathParams, requestParams) => {
    let path = null
    if (pathParams) {
      path = Object.keys(pathParams).map(key => key + '/' + pathParams[key]).join('/')
    }

    let queryString = null;
    if (requestParams) {
      let qsArray = Object.entries(requestParams).map(item => `${item[0]}=${item[1]}`)
      queryString = qsArray.join('&')
    }

    let getResource = `${RestApiUtils.getServerUrl(context)}${resource}` +
      (path ? `/${path}` : '') +
      (queryString ? `?${queryString}` : '')

    console.log('-> GET', getResource)

    fetch(getResource, {
      headers: RestApiUtils.getHeaders(context)
    })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      return response.json()
    })
    .then((json) => {
      console.log('<- GET', getResource, json);
      RestApiUtils.checkSessionError(json)
      callback(json)
    })
    .catch((error) => {
      console.error('GET request failed:', getResource, error)
      callback({
        success: false,
        errorList: [`Network error: ${error.message}`]
      })
    })
  },

  patch: (context, resource, callback, body) => {
    let patchResource = RestApiUtils.getServerUrl(context) + resource
    console.log('-> PATCH', patchResource, body)

    fetch(patchResource, {
      method: 'PATCH',
      headers: RestApiUtils.getHeaders(context),
      body: JSON.stringify(body)
    })
    .then((response) => {
      // Try to parse JSON; if not ok, throw to catch below
      return response.json().catch(() => {
        throw new Error(`Invalid JSON response for PATCH ${patchResource}`)
      })
    })
    .then((json) => {
      console.log('<- PATCH', patchResource, json)
      RestApiUtils.checkSessionError(json)
      callback(json)
    })
    .catch((error) => {
      console.error('PATCH error:', error)
      callback({
        success: false,
        errorList: [{ message: `Network/CORS error while calling PATCH: ${error.message}` }]
      })
    })
  },

  post: (context, resource, callback, body) => {
    let postResource = RestApiUtils.getServerUrl(context) + resource
    console.log('-> POST', postResource, body)

    fetch(postResource, {
      method: 'post',
      headers: RestApiUtils.getHeaders(context),
      body: JSON.stringify(body)
    })
    .then((response) => {
      // Check if response has content before parsing JSON
      const contentType = response.headers.get('content-type')
      if (contentType && contentType.includes('application/json')) {
        return response.json()
      } else if (response.status === 201 || response.status === 202 || response.status === 204) {
        // HTTP 201 Created, 202 Accepted, or 204 No Content - return empty success response
        return { success: true, errorList: [] }
      } else {
        // Try to parse as JSON, but handle empty body
        return response.text().then(text => {
          return text ? JSON.parse(text) : { success: true, errorList: [] }
        })
      }
    })
    .then((json) => {
      console.log('<- POST', postResource, json)
      RestApiUtils.checkSessionError(json)
      callback(json)
    })
    .catch((error) => {
      console.error('POST error:', error)
      callback({
        success: false,
        errorList: [{ message: `Network/Parse error: ${error.message}` }]
      })
    })
  },


  postFile: (context, resource, callback, file, fieldName = 'file') => {
    let postResource = RestApiUtils.getServerUrl(context) + resource
    console.log('-> POST FILE', postResource, file.name, 'Size:', file.size, 'Type:', file.type)

    const formData = new FormData()
    formData.append(fieldName, file)

    const headers = RestApiUtils.getHeaders(context)
    delete headers['Content-Type']

    console.log('FormData created with field:', fieldName, 'File:', file.name)

    fetch(postResource, {
      method: 'POST',
      headers: headers,
      body: formData
    })
    .then((response) => {
      console.log('Response status:', response.status)
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      return response.json()
    })
    .then((json) => {
      console.log('<- POST FILE', postResource, json)
      RestApiUtils.checkSessionError(json)
      callback(json)
    })
    .catch((error) => {
      console.error('File upload error:', error)
      callback({
        success: false,
        errorList: [`File upload failed: ${error.message}`]
      })
    })
  },

  put: (context, resource, callback, body) => {
    let putResource = RestApiUtils.getServerUrl(context) + resource
    console.log('-> PUT', putResource, body)

    fetch(putResource, {
      method: 'put',
      headers: RestApiUtils.getHeaders(context),
      body: JSON.stringify(body)
    })
    .then((response) => {
      if (response.status === 204 || response.status === 201 || response.status === 202) {
        return { success: true, errorList: [] }
      } else {
        return response.text().then(text => {
          try {
            return text ? JSON.parse(text) : { success: true, errorList: [] }
          } catch (e) {
            return { success: response.ok, errorList: response.ok ? [] : [{ message: text }] }
          }
        })
      }
    })
    .then((json) => {
      console.log('<- PUT', putResource, json)
      RestApiUtils.checkSessionError(json)
      callback(json)
    })
    .catch((error) => {
      console.error('PUT error:', error)
      callback({
        success: false,
        errorList: [{ message: `Network/Parse error: ${error.message}` }]
      })
    })
  },

  delete: (context, resource, callback, body) => {
    let deleteResource = RestApiUtils.getServerUrl(context) + resource
    console.log('-> DELETE', deleteResource)

    fetch(deleteResource, {
      method: 'delete',
      headers: RestApiUtils.getHeaders(context),
      body: JSON.stringify(body)
    })
    .then((response) => {
      return response.json()
    })
    .then((json) => {
      console.log('<- DELETE', deleteResource, json);
      RestApiUtils.checkSessionError(json)
      callback(json)
    })
      .catch(err => {
        console.log(err)
      })
  },

  getGetMethodResource: (context, resource, params) => {
    let path = Object.keys(params).map(key => key + '/' + params[key]).join('/')
    let getResource = RestApiUtils.getServerUrl(context) + (path ? `${resource}/${path}` : resource)
    console.log('GET', getResource)
    return getResource
  },

  getPostMethodResource: (context, resource) => {
    let postResource = RestApiUtils.getServerUrl(context) + resource
    console.log('POST', postResource)
    return postResource
  },

  getHeaders: (context) => {
    let headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${context.session.sessionId}`,
      'Locale': context.locale,
      'Country-Code': context.account ? context.account.countryCode : context.session.countryCode,
      'ECID': context.ecid
    }
    return headers
  },

  // unused
  getFormData: (params) => {
    let formData = new FormData()
    Object.keys(params).forEach(key => formData.append(key, params[key]))
    return formData
  },

  checkSessionError: (json) => {
    if (json.errorList && json.errorList.length > 0 && json.errorList[0].fieldName === 'sessionId') {
      console.log('invalid session')
      localStorage.removeItem(LocalStorageKeys.Session)
      localStorage.removeItem(LocalStorageKeys.Session + ':CachedTime')
      setTimeout(() => {
        window.location = '/pub/message?key=invalid_session'
      }, 10);
    }
  },

  getServerUrl: (context) => {
    if (window.location.host.startsWith('localhost')) {
      if (context.apiHost)
        return context.apiHost
      return 'http://localhost:8080'
    }

    switch (window.location.host) {
      case 'teambrew.com':
        return 'https://api.teambrew.com'
      case 'dev.teambrew.com':
        return window.location.protocol + '//api-dev.teambrew.com'
      // ---------------
      case 'payminder.com':
      case 'beta.payminder.com':
        return window.location.protocol + '//api.payminder.com'
      // ---------------
      case 'dev.payminder.com': // remove
        return window.location.protocol + '//api-dev.payminder.com' // remove
      // ---------------
      case 'dev.vert-one.com':
        return window.location.protocol + '//api-dev.vert-one.com'
      case 'demo.vert-one.com':
        return window.location.protocol + '//api-demo.vert-one.com'
      case 'stage.vert-one.com':
        return window.location.protocol + '//api-stage.vert-one.com'
      case 'new-stage.vert-one.com':
        return window.location.protocol + '//api-new-stage.vert-one.com'
      case 'app.vert-one.com':
        return window.location.protocol + '//api.vert-one.com'
      default:
    }
  }
}

export default RestApiUtils
